/* eslint-disable max-len */
import {
  Dot, Nbr,
} from './style';

interface IBulle {
  count: number
}

const BulleCounter: React.FC<IBulle> = ({
  count,
}) => (
  <Dot>
    <Nbr>{count}</Nbr>
  </Dot>
);

export default BulleCounter;
